module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/123.6a2164c6.png";